import path from 'path'
import Vue from 'vue'

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.auth.user,
    has: (state, getters, rootState) => (roleOrPermission) => {
        let user = rootState.appStore.auth.user

        let userRoles = _.get(user, "roles", [])
        let userPermissions = _.get(user, "permissions", [])

        let rolePermissions = _.uniqBy(_.flatten(userRoles.map((userRole) => userRole.permissions)), "name")
        let allPermissions = _.uniqBy([...userPermissions, ...rolePermissions], "name")
        let rolesAndPermissions = [...userRoles, ...allPermissions]
        rolesAndPermissions = rolesAndPermissions.filter((rolesAndPermission) => rolesAndPermission)
        if (_.isArray(roleOrPermission)) {
            return rolesAndPermissions.some((userPermission) => roleOrPermission.includes(userPermission.name))
        }
        return rolesAndPermissions.some((userPermission) => userPermission.name == roleOrPermission)
    },
    isBroker: (state, getters, rootState) => {
        return getters.has("broker")
    },
    isReferrer: (state, getters, rootState) => {
        return getters.has("referrer")
    },
    isAcrReferrer: (state, getters, rootState) => {
        return getters.has("referrer") && getters.has("show application tab")
    },
    isAcrReferrerExt: (state, getters, rootState) => {
        return getters.has("referrer") && getters.has("show application tab") && getters.has("show lender submission tab")
    },
    isNonAcrReferrer: (state, getters, rootState) => {
        return getters.has("referrer") && !getters.has("show application tab")
    },
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {
    setUser(state, user) {
        Vue.set(this.state.appStore.auth, 'user', {...this.state.appStore.auth.user, ...user})
    },
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    set({ commit }, user) {
        commit("setUser", user)
    }
}

export default {
    namespaced: true,
    namespace: "auth/user",
    state: {},
    getters,
    mutations,
    actions
}
